// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1idvs","questions":"styles_questions__2uZCV","footer":"styles_footer__fw45B"};